import React from 'react';

import { createSafeContext } from '../safe-context';

interface IIdentity {
  email?: string;
  firstName?: string;
  lastName?: string;
}

interface IIdentityContext {
  identity: IIdentity;
  setIdentity: (identity: IIdentity) => void;
}

const [useIdentity, Provider] = createSafeContext<IIdentityContext>();

const IdentityProvider = ({ children }: { children: React.ReactNode }) => {
  const [identity, setIdentity] = React.useState<IIdentity>({});

  const setIdentityWrapper = React.useCallback((newIdentity: IIdentity) => {
    setIdentity(newIdentity);
    window.localStorage.setItem('identity', JSON.stringify(newIdentity));
  }, []);

  if (typeof window !== 'undefined') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useLayoutEffect(() => {
      const storedIdentity = window.localStorage.getItem('identity');

      if (storedIdentity) {
        try {
          setIdentity(JSON.parse(storedIdentity));
        } catch {
          window.localStorage.removeItem('identity');
        }
      }
    }, []);
  }

  return <Provider value={{ identity, setIdentity: setIdentityWrapper }}>{children}</Provider>;
};

export { useIdentity, IdentityProvider };
